import React, { useState } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "tss-react/mui";

import DataTableRow from "./DataTableRow";
import useWindowResize from "../../hooks/useWindowsReszie";

const columns = [
  {
    label: "Component",
    id: "component",
    width: 250,
  },
  {
    label: "Field",
    id: "field",
    width: 250,
  },
  {
    label: "Rules (Click on icon to see details)",
    id: "rules",
    width: 500,
  },
];

const useStyles = makeStyles()(() => ({
  TableHead: {
    fontWeight: 600,
    "& span.Mui-active": {
      background: "transparent",
      color: "inherit",
    },
    "& span": {
      "&:hover": {
        background: "transparent",
        color: "rgba(0, 0, 0, 0.6) !important",
      },
    },
  },
  pagination: {
    "& p": {
      marginBottom: "0px",
    },
  },
}));

function DataTable({ rules, loading, count, limit, currentPage, handleChangePage, handleChangeRowsPerPage }) {
  const { classes } = useStyles();
  const { height: tableHeight } = useWindowResize(260);

  const [open, setOpen] = useState({ id: null, open: false });

  return (
    <Paper sx={{ width: "100%", mb: 2 }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: `${tableHeight}px`,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          sx={{
            maxHeight: `${tableHeight}px`,
            ...(rules.length === 0
              ? {
                  overflow: "hidden",
                }
              : {}),
          }}
        >
          <Table stickyHeader sx={{ width: "100%" }} size="small">
            <TableHead>
              <TableRow>
                {columns.map((headCell) => (
                  <TableCell
                    key={headCell.id}
                    style={{
                      width: headCell.width,
                      minWidth: headCell.id !== "rules" ? 200 : 400,
                    }}
                    className={classes.TableHead}
                  >
                    {headCell.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {rules.length ? (
              <TableBody>
                {rules.map((row) => (
                  <DataTableRow key={row.ID} row={row} collapseOpen={open} setCollapseOpen={setOpen} />
                ))}
              </TableBody>
            ) : (
              <TableBody></TableBody>
            )}
          </Table>
        </TableContainer>
      )}
      <>
        {!rules.length && !loading && (
          <div
            style={{
              height: tableHeight - 64, //64 for the table title space
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No rules defined
          </div>
        )}
      </>
      <TablePagination
        className={classes.pagination}
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={count}
        rowsPerPage={limit}
        page={currentPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default React.memo(DataTable);
